import React from 'react';
import { Routes, Route } from 'react-router-dom';

import { BuyerList, BuyerProfile, CreateBuyer } from './components';

export const BuyersPage: React.FC = () => {
  return (
    <Routes>
      <Route index element={<BuyerList />} />
      <Route path="create" element={<CreateBuyer />} />
      <Route path=":buyerId" element={<BuyerProfile />} />
    </Routes>
  );
};
